 <template>
    <div v-if="display">
        <div class="container header-margin">

            <div class="text-center p-2 text-color text-area">
                <h2 class="main_title">{{ $t('aube_quest.registration.title') }}</h2>
            </div>

            <div class="info-box">
                <small class="text-muted">{{ $t('aube_quest.registration.title_quest_info') }}</small>
                <div>Quest ID: {{ quest_id }}</div>
                <div>Connector ID: {{ connectorMemberId }}</div>
                <div>{{ $t('aube_quest.connector_start_date') }}: {{ joinedDate }}</div>
                <div v-if="errors.quest_id_error" class="error-message">{{ errors.quest_id }}</div>
            </div>

            <div class="tab-content p-2">
                <div class="row no-gutters text-center navigation">
                    <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title1') }}</p></div>
                    <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title2') }}</p></div>
                    <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title3') }}</p></div>
                    <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title4') }}</p></div>
                </div>

                <div class="text-center p-2 text text-color text-area">
                    <h3 class="sub_title">{{ $t('auth.signupMailForceclub') }}</h3>
                </div>

                <div class="tab-content p-2" >
                    <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-create-tab">
                        <div class="message-bottom">
                            <label class="col-form-label pre" v-html="$t('createUserMessage.EmailSendMessageAube')"></label>
                        </div>

                        <div class="pt-5 text-center">
                            <router-link to="/" class="btn btn-primary pr-5 pl-5 active-color-box">{{ $t('auth.backTopBtn') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

    import UserService from '../../../../services/UserService';
    import languageService from "../../../../services/LanguageService";
    import questService from "../../../../services/QuestService";

    export default {
        name: 'registration-module',
        created() {
            this.quest_id = localStorage.getItem('questId');
            if (!localStorage.getItem('questId')) {
                this.errors.quest_id_error = this.$t('aube_quest.verify_error.quest_id_not_found');
                return;
            }
            this.getConnector(this.quest_id);
        },
        data() {
            return {
                display: false,
                quest_id: '',
                connectorMemberId: '',
                joinedDate: '',
                errors: {
                    quest_id_error: ''
                }
            }
        },
        mounted() {
            this.fetchUserData();
        },

        methods: {
            async fetchUserData() {
                try {
                    if(sessionStorage.mailData){
                        this.mailData = JSON.parse(sessionStorage.mailData);
                        const result = await UserService.getUserConfirmDataByMail(this.mailData);
                        if(result.data.member_type_id == 2100 || result.data.member_type_id == 2200){
                            this.$router.push('/');
                        } else {
                            this.display = true
                            this.maxHeight();
                        }
                    } else {
                        this.display = true
                        this.maxHeight();
                    }
                } catch (e) {
                    this.$router.push('/');
                }
            },
            async maxHeight() {
                setTimeout(() => {
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                 }, 1000);
            },
            async getConnector (questId) {
                try {
                    const result = await questService.getConnectorByQuestId(questId);
                    this.connectorMemberId = result.data.connector_id;
                    this.joinedDate = result.data.joined_date;
                } catch (error) {
                }
            },
        },
    }
</script>
<style scoped>
    .main_title {
        margin-bottom:15px;
    }
    .sub_title {
        margin-bottom:15px;
    }
    .tos.form-control:disabled {
        background-color: white;
    }
    .tosAgreeForm {
        cursor: pointer;
    }
    .pre {
        white-space: pre-wrap;
    }
    .active-color-box {
        background: #451493;
        border-color: #FFF;
    }
    .non-active-color-box {
        background: #bdbebd;
    }
    .text {
        font-size: 25px;
    }
    .text-area {
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4 {
        outline: 1px solid #FFF;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }
    .header-margin {
        top:250px;
    }
    .navigation {
        padding-top: 15px;
        padding-bottom:40px;
    }
    .text-color {
        color: #451493;
    }
    .message-bottom {
        padding-bottom:50px;
        padding-top: 3%;
        padding-left: 2%;
    }

    .info-box {
        background-color: #f7f7f7;
        border-radius: 6px;
        padding: 12px 16px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #ebeaea;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
    .info-box small {
        display: block;
        color: #6c757d;
        margin-bottom: 4px;
        font-size: 0.85rem;
    }
    .info-box div {
        font-weight: 500;
        font-size: 0.95rem;
    }

    .error-message {
        display: block;
        margin-top: 0.25rem;
        font-size: 0.875rem;
        color: #e3342f;
        line-height: 1.4;
        word-wrap: break-word;
        max-width: 300px;
    }

    /*スマホ用css*/
    @media screen and (max-width: 479px) {
        .header-margin {
            padding-left: 0px;
            padding-right: 0px;
        }
        .main_title {
            font-size: 1.575rem;
            margin-bottom: 0px;
        }
        .sub_title {
            font-size: 1.3rem;
            margin-bottom: 0px;
        }
        .navigation {
            padding-top: 0px;
            padding-bottom:15px;
        }
        .pre {
            margin-top: 25px;
        }
        .message-bottom {
            padding-top: 0%;
        }
        .col-form-label {
            margin-top:0px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 471px) {
        .box-area[data-v-40212d93] {
            height: 90px;
        }
    }
</style>
